<template>
	<div class="containerBox" style="">
		<div class="leftBox">
			<div class="wjTypeChild" :style="{ height: height + 'px' }">
				<div
					style="text-align: center"
					class="wjTypeChildItemFont"
					:class="{
						wjTypeChildItem: index != 0,
						iconActive: index == selectIndex
					}"
					v-for="(item, index) in Channels_share"
					:key="item.id"
				>
					<div class="icon" @click="selectInd(item.id)" v-show="item.show">
						<img :src="item.icon2" v-if="index == selectIndex" />
						<img :src="item.icon" v-else />
					</div>
					<span @click="selectInd(item.id)" v-show="item.show">{{ item.label }}</span>
				</div>
			</div>
		</div>
		<el-container id="wenjuan_list" class="wjEdit">
			<router-view></router-view>
		</el-container>
		<el-dialog :title="$t('PublishProject.ModificationPrompt')" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
			<div><span>{{$t('PublishProject.AreYouSureToModifyThisQuestionnaire')}}</span></div>

			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="handleConfirmClick">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'wjPub',
	watcTemplateh: {
		qtypeval(val) {
			if (val == this.$t('PublishProject.QuestionControl')) {
				this.selectIndex = 0;
			} else if (val == this.$t('PublishProject.MyQuestionBank')) {
				this.selectIndex = 1;
			}
		},
		selectIndex(val) {
			if (val == 0) {
				this.qtypeval = this.$t('PublishProject.QuestionControl');
			} else if (val == 1) {
				this.qtypeval = this.$t('PublishProject.MyQuestionBank');
			}
		}
	},
	data() {
		return {
			redpacketpacket: false,
			dialogVisible: false,
			next: null,
			Email_error: true,
			inputEmail: '',
			checked: '',
			label: '',
			activephone: 0,
			publicPage: true,
			activeName: 'first',
			input: this.$t('PublishProject.Investigate'),
			logoImg: require('../assets/tx/logo_share.png'),
			display: 'none',
			left: 0,
			top: 0,
			curWjInfo: {},
			questionlist: [],
			selectIndex: 0,
			selectTypeIndex: 0,
			isCollapse: true,
			activeNames: [0, 1, 2],
			asklist: [],
			qtypes: [this.$t('PublishProject.QuestionControl'), this.$t('PublishProject.MyQuestionBank')],
			qtypeval: this.$t('PublishProject.QuestionControl'),
			height: 0,
			rightheight: 0,
			activeIndex: '0',
			editIndex: -1,
			editOptionIndex: '0_0',
			wjTypeList: [],
			typeIndex: -1,
			centerDialogVisible: false,
			tkList: [],
			curTkType: {},
			curSzType: {},
			searchQuestionsName: '',
			showSzDialog: false,
			Channels_share_id: '',
			selectId: 0,
			Channels_share: [
				{
					id: '0',
					label: this.$t('PublishProject.ShareLink'),
					icon: require('../assets/tx/lianjie.png'),
					icon2: require('../assets/tx/lianjie1.png'),
					path: '/wjmanage/wjpub/shareLink',
					show: true
				},
				{
					id: '1',
					label: this.$t('PublishProject.SMSSharing'),
					icon: require('../assets/tx/shouji.png'),
					icon2: require('../assets/tx/shouji1.png'),
					path: '/wjmanage/wjpub/messageShare',
					show: false
				},
				{
					id: '2',
					label: this.$t('PublishProject.EmailSharing'),
					icon: require('../assets/tx/youjian.png'),
					icon2: require('../assets/tx/youjian1.png'),
					path: '/wjmanage/wjpub/emailShare',
					show: false
				},
				{
					id: '3',
					label: this.$t('PublishProject.TelephoneSurveys'),
					icon: require('../assets/tx/tab_phone.png'),
					icon2: require('../assets/tx/tab_phone1.png'),
					path: '/wjmanage/wjpub/telecommunications',
					show: false
				},

				{
					id: '4',
					label: this.$t('PublishProject.Interview'),
					icon: require('../assets/tx/interview.png'),
					icon2: require('../assets/tx/interview1.png'),
					path: '/wjmanage/wjpub/discussPersonally',
					show: false
				},
				{
					id: '5',
					label: this.$t('PublishProject.SetUp'),
					icon: require('../assets/tx/tab_def_icon5.png'),
					icon2: require('../assets/tx/tab_sel_icon5.png'),
					show: false,
					// path: '/questionSetting',
					path: '/wjmanage/wjpub/questionSetting',
				}
				// {
				//   id: "3",
				//   label: "样本收集",
				//   icon: require("../assets/tx/ico_sample.png"),
				//   icon2: require("../assets/tx/ico_sample2.png"),
				// },
				// {
				//   id: "4",
				//   label: "申请推荐",
				//   icon: require("../assets/tx/ico_recommend.png"),
				//   icon2: require("../assets/tx/ico_recommend2.png"),
				// },
			],
			uploadPicUrl: '', //提交到后台图片地址
			content: '',
			arr11: [],
			len: '',
			inputname: '',
			beensent: [],
			page_value: false,
		};
	},
	computed: {
		...mapState(['headers'])
	},
	mounted() {
		let that = this;
		this.loadAskTypeData();
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};

		//在mounted钩子函数绑定滚动条事件
		document.getElementById('wenjuan_list').addEventListener('scroll', this.scroll);
		that.wid = sessionStorage.getItem('wid');
		if (that.wid == 0) {
			this.wjadd();
		} else {
			this.wjinfo();
		}

		this.loadWjTypes();
	},
	created() {
		if (this.$route.query.selectIndex == undefined) {
			this.selectIndex = 0;
			this.curWjInfo.state = 0;
		}
		// 修改url地址栏 将操作返回功能时 添加的selectIndex进行删除处理
		var stateObject = {};
		var oldUrl = window.location.href;
		// 注释代码：以?为分隔符，去除最后一个值
		oldUrl = oldUrl.split('?');
		delete oldUrl[oldUrl.length - 1];
		// 注释代码：将转换去掉之后的地址栏数据用‘/’拼接成字符串，
		oldUrl = oldUrl.join('/');
		var title = '';
		var newUrl = oldUrl;
		history.pushState(stateObject, title, newUrl);
		this.accessPermission();
	},

	methods: {
		accessPermission() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			// console.log(userInfo.permissionList);
			let arr = userInfo.permissionList;
			let permissionList = {};
			arr.forEach((item, index) => {
				permissionList['admin' + item] = item;
			});
			// console.log(permissionList);
			// this.permissionList = permissionList;
			this.Channels_share.forEach(item => {
				// 短信分享
				if (permissionList.admin1008) {
					if (item.id == 1) {
						item.show = true;
					}
				} else {
					if (item.id == 1) {
						item.show = false;
					}
				}
				// 邮件分享
				if (permissionList.admin1009) {
					if (item.id == 2) {
						item.show = true;
					}
				} else {
					if (item.id == 2) {
						item.show = false;
					}
				}
				// 电访
				if (permissionList.admin1010) {
					if (item.id == 3) {
						item.show = true;
					}
				} else {
					if (item.id == 3) {
						item.show = false;
					}
				}
				// 面访
				if (permissionList.admin1011) {
					if (item.id == 4) {
						item.show = true;
					}
				} else {
					if (item.id == 4) {
						item.show = false;
					}
				}
				// 设置
				if (permissionList.admin1007) {
					if (item.id == 5) {
						item.show = true;
					}
				} else {
					if (item.id == 5) {
						item.show = false;
					}
				}
			});
		},
		GoGo(value) {
			this.redpacketpacket = false;
		},
		redpacket(value) {
			this.redpacketpacket = true;
		},
		
		clickaddEmail(val) {},
		clickadd(val) {},
		saveGroup(value) {
			console.log('value', value);
		},
		
		handleNodeClick(data) {
			console.log('组', data);
		},
		accomplish() {
			this.publicPage = true;
			this.active = 0;
		},
		handleClick(tab, event) {
			console.log(tab, event);
		},
		selectInd(item) {
			this.selectIndex = item;
			let active = this.Channels_share.filter((info) => {
				if (info.id == item) {
					return true
				}
			})
			let wstate = sessionStorage.getItem('wstate')
			if ( wstate == 1 && ( item == 0 || item == 1 || item == 2 )) {
				this.$router.push({ path: '/wjmanage/wjpub/publishProject' })
				return
			}

			let data = { wid: this.wid }
			this.$router.push( { path: active[0].path, query: data })

		},
		switch1() {
			this.$message.success(this.$t('PublishProject.SetBerjaya'));
		},
		scroll() {
			let that = this;
			that.display = 'none';
		},
		loadAskTypeData() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.questionTypeList,
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.asklist = res.resultBody.questionTypeOneList;
						that.asklist = that.asklist.map((info) => {
							info.questionTypeList = info.questionTypeList.map(val => {
								val.type = val.type?.toString()
								return val
							})
							return info
						})
					}
				}
			};
			this.$util.request(params);
		},
		wjinfo() {
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.wjinfo}?id=${id}`,
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.curWjInfo = res.resultBody;
						if (that.curWjInfo.state == 1) {
							that.$router.push({ path: '/wjmanage/wjpub/publishProject' })
						} else {
							that.selectInd(that.$route.query.selectIndex || that.selectIndex);
						}
						that.input = res.resultBody.wjTitle;
						that.content = res.resultBody.content;
					}
				}
			};
			this.$util.request(params);
		},
		wjadd() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.wjadd,
				data: {
					content: '',
					wjTitle: '问卷标题',
					wjType: '问卷类型'
				},
				cb(res) {
					if (res.code == 0) {
						that.curWjInfo = res.resultBody;
						if (that.curWjInfo.state == 1) {
							that.$router.push({ path: '/wjmanage/wjpub/publishProject' })
						} else {
							that.selectInd(that.$route.query.selectIndex || that.selectIndex);
						}
						// that.loadQuestionList();
					}
				}
			};
			this.$util.request(params);
		},
		selectTypeQuestion(index, item) {
			this.selectTypeIndex = index;
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.questionadd,
				data: {
					questionnaireId: that.curWjInfo.id,
					questionsTypeId: item.id
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						that.questionlist.push(res.resultBody);
						that.editIndex = that.questionlist.length - 1;
						that.editCurQuestion = that.questionlist[that.editIndex];
						setTimeout(() => {
							let div = document.getElementById('wenjuan_list');
							div.scrollTop = div.scrollHeight;
						}, 400);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		addQuestionItem(item) {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.questionadd,
				data: {
					questionnaireId: that.curWjInfo.id,
					questionsId: item.id
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						item.questionsSonList.push(res.resultBody);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		selectIcon(index) {
			this.selectId = index;
		},
		wjaddquestionoption(options, item, type = 0) {
			if (type == 2) {
				this.editCurQuestion = item;

				this.batchDialog = true;
				this.batchlist = '';
				return;
			}
			let url = `${this.$config.service.addoneoption}?id=${item.id}`;
			if (type == 1) {
				url = `${this.$config.service.addoneotheroption}?id=${item.id}`;
			}
			let that = this;
			let params = {
				that: this,
				url: url,
				data: {},
				cb(res) {
					if (res.code == 0) {
						options.push(res.resultBody);
						that.$message.success(res.message);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		addMatrixQuestionsOption(options, item) {
			let url = `${this.$config.service.addMatrixQuestionsOption}`;
			let that = this;
			let params = {
				that: this,
				url: url,
				data: {
					questionsId: item.id
				},
				cb(res) {
					if (res.code == 0) {
						options.push(res.resultBody.datas[0]);
						that.$message.success(res.message);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		wjdelquestionoption(options, item, childindex) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.deloneoption}?id=${item.id}`,
				data: {},
				cb(res) {
					if (res.code == 0) {
						options.splice(childindex, 1);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		questiondel(id) {
			let that = this;
			this.$confirm(this.$t('PublishProject.PadamSecaraKekal'), this.$t('main.tip'), {
				confirmButtonText: this.$t('main.ok'),
				cancelButtonText: this.$t('main.cancel'),
				type: 'info'
			})
				.then(() => {
					let params = {
						that: that,
						url: `${that.$config.service.questiondel}?id=${id}`,
						data: {},
						cb(res) {
							if (res.code == 0) {
								that.questionlist = [];
								// that.loadQuestionList();
								that.$message.success(res.message);
								return;
							}
							that.$message.error(res.message);
						}
					};
					that.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('PublishProject.CancelledDeletion')
					});
				});
		},
		showAdvance() {
			//let that = this;
			//let x = that.getLeft(e.currentTarget);
			//let y = that.getTop(e.currentTarget);
			//that.display = "inline";
			//that.left = x;
			//that.top = y - document.getElementById("wenjuan_list").scrollTop;
		},
		setEditIndex(index) {
			let that = this;
			let curselected = document.getElementById(this.editIndex);
			if (curselected) {
				curselected.classList.remove('item_container_hover');
			}
			document.getElementById(index).classList.add('item_container_hover');
			this.editIndex = index;
			that.editCurQuestion = that.questionlist[that.editIndex];
			that.ifMustAnswer = that.editCurQuestion.ifMustAnswer == 1 ? true : false;
			that.optionIfRandom = that.editCurQuestion.optionIfRandom == 1 ? true : false;
		},
		setEditOptionIndex(childIndex) {
			this.editOptionIndex = this.editIndex + '_' + childIndex;
		},
		wjupdquestionoption(item) {
			let url = `${this.$config.service.questionupd}`;
			let that = this;
			let params = {
				that: this,
				url: url,
				data: {
					id: item.id,
					questionsName: item.questionsName
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		wjupdoption(item) {
			let url = `${this.$config.service.questionupdoption}`;
			let that = this;
			let params = {
				that: this,
				url: url,
				data: {
					id: item.id,
					labelName: item.labelName
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		wjedit() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.wjedit,
				data: {
					content: that.curWjInfo.content,
					wjTitle: that.curWjInfo.wjTitle,
					id: that.curWjInfo.id
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		loadWjTypes() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.queryQuestionTypes,
				data: {},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.wjTypeList = res.resultBody.datas;
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		showQuestionList(index, item) {
			this.centerDialogVisible = true;
			this.typeIndex = index;
			this.curTkType = item;
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.queryTestQuestions,
				data: {
					questionTypeId: item.id,
					questionsName: that.searchQuestionsName
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.tkList = res.resultBody.datas;
						return;
					} else {
						that.tkList = [];
					}
					//that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		addTkItem(item) {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.addNewQuestions,
				data: {
					questionnaireId: this.curWjInfo.id,
					questions: [item.id]
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.centerDialogVisible = false;
						// that.loadQuestionList();
						setTimeout(() => {
							let div = document.getElementById('wenjuan_list');
							div.scrollTop = div.scrollHeight;
						}, 400);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		selectSzItem(item) {
			this.showSzDialog = true;
			this.curSzType = item;
		},
		
		
		handleClose() {
			this.dialogVisible = false;
		},
		handleConfirmClick() {
			this.dialogVisible = false;
			this.wid = sessionStorage.getItem('wid') || 0;
			this.$api.UpdateQuestionnaireState({ id: this.wid, state: 1 })
		    .then((res) => {
		      console.log(res);
			  sessionStorage.setItem('wstate', 1);
		    })
		    .catch((error) => {
		      console.log(error);
		    });

			this.next();
		},

	},
	beforeCreate() {
		this.$forceUpdate();
	},

	beforeRouteLeave(to, from, next) {
		// 导航离开该组件的对应路由时调用
		// 可以访问组件实例 `this`
		console.log({ to, from, next });
		console.log('to.name :>> ', to.name);
		if (to.name != 'QuestionType') {
			next();
		} else {
			let state = sessionStorage.getItem('wstate');
			console.log('state :>> ', state);
			if (state && state != 1) {
				this.next = next;
				this.dialogVisible = true;
			} else {
				next();
			}
		}
	}
};
</script>

<style scoped lang="scss">

.containerBox {
	display: flex;
	justify-content: space-around;
	.leftBox {
		width: 80px;
		min-width: 80px;
		background: #fff;
		// border-right: 1px solid #dde5ed;
		border-right: 1px solid #ccc;
		.share {
			font-size: 12px;
			text-align: center;
			margin: 30px 0;

			img {
				width: 40px;
			}
		}
	}
	.rightBox {
		width: 320px;
		background: #fff;
		border-left: 1px solid #dde5ed;
	}
}
.typesetting {
	width: 300px;
	height: 865px;
	overflow-y: auto;
	// overflow-x: hidden;
	position: fixed;
	top: 60px;
	right: 0px;
	background: #fafafa;
	z-index: 1;
}
.typesetting::-webkit-scrollbar {
	/*滚动条整体样式*/
	width: 1px; /*高宽分别对应横竖滚动条的尺寸*/
	height: 10px;
}
.typesetting::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px #f1f1f1;
	background: #535353;
}
.typesetting::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	-webkit-box-shadow: inset 0 0 5px #f1f1f1;
	border-radius: 10px;
	background: #ededed;
}
.answer_set_ul {
	width: 300px;
}

.button_line {
	width: 300px;
}
.button_line span i {
	width: 16px;
	height: 16px;
}

.limit_num_box {
	width: 300px;
}
.limit_num {
	width: 300px;
	margin-left: 10px;
}
.collection_method {
	width: 300px;
}
.wjTypeChild {
	overflow-y: hidden;
	position: fixed;
	top: 61px;
	z-index: 111;
	height: 853px;
	width: 80px;
	background-color: #fff;
	padding-top: 15px;
	padding-bottom: 30px;
	float: left;
	display: inline;
	.wjTypeChildItemFont {
		font-size: 14px;
		cursor: pointer;
		.icon {
			margin: 0px auto;
			width: 50px;
			height: 50px;
			border-radius: 5px;
			img {
				margin-top: 12px;
			}
		}
	}
	.wjTypeChildItem {
		text-align: center;
		margin-top: 40px;
	}
	.iconActive {
		color: #0080ff;
	}

	.iconActive > .icon {
		background-color: #0080ff;
	}
}
</style>

<style scoped>
.sendData h3 i {
	width: 18px;
	height: 18px;
	position: absolute;
	top: 0px;
	right: 25px;
}
.sendData h3 {
	color: #353535;
	font-size: 16px;
	font-weight: bold;
	padding-left: 25px;
	border-bottom: #eeeff1 solid 1px;
	position: relative;
	height: 30px;
}
/* 遮罩层 */
.sendMask {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 1001;
	width: 100%;
	height: 100%;
	background-color: #000;
	opacity: 0.3;
}
/* 短信确认发送遮罩层 */
.sendData {
	position: fixed;
	background: #fff;
	width: 600px;
	min-height: 350px;
	overflow: auto;
	opacity: 1;
	z-index: 2001;
	top: 30%; /*偏移*/
	left: 50%;
	margin-left: -300px;
	border-radius: 5px;
}


.emaileAuccess {
	width: 90px;
	height: 38px;
	margin-left: 400px;
	border: none;
	background: #0080ff;
	color: #fff;
	border-radius: 3px;
	margin-top: 30px;
	margin-bottom: 40px;
}

/deep/.sendSelect .el-input__inner {
	width: 140px !important;
	height: 30px !important;
}
/deep/.sendSelect .el-input__suffix {
}
.custom-tree-node {
	width: 254px;
	position: relative;
	display: flex;
	align-items: center;
    justify-content: space-between;
}
.custom-tree-node .btn {
	color: #0080ff;
    font-size: 14px;
    cursor: pointer;
}


.treeBox2_a {
	padding: 1px;
	display: block;
	color: #666;
}






.sendContent {
	width: 926px;
	height: 343px;
	border: 1px solid #ccc;
	padding-top: 38px;
	padding-left: 25px;
}


.Manually_enter_contacts {
	width: 646px;
	height: 518px;
	border: 1px solid #ccc;
	overflow: auto;
}
/*div富媒体 短信*/
#MailCon {
	outline: none;
}






.contact_list {
	width: 254px;
	height: 518px;
	border: 1px solid #cccccc;
}






.tabPaneBox {
	width: 752px;
	margin-left: 24px;
}
.websites_content {
	width: 800px;
	height: 430px;
	background: #fff;
	box-shadow: 2px 2px 5px #ccc;
	border-radius: 3px;
	margin-top: 15px;
	margin-bottom: 34px;
}
.custom_text_box {
	width: 800px;
	border-bottom: 1px solid #e3e3e8;
	display: flex;
	justify-content: center;
}
.custom_text {
	width: 740px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.custom_content {
	width: 800px;
	height: 98px;
	background: #fff;
	box-shadow: 2px 2px 5px #ccc;
	border-radius: 3px;
	margin-top: 15px;
	margin-bottom: 34px;
}
.share_custom {
}














.Channels_content {
	width: 800px;
	height: 190px;
	background: #fff;
	box-shadow: 2px 2px 5px #ccc;
	border-radius: 3px;
	margin-top: 15px;
	margin-bottom: 34px;
	display: flex;
	justify-content: space-around;
	align-items: center;
}



.wjType {
	width: 360px;
	float: left;
	display: inline;
}

.wjEdit {
	height: calc(100vh - 60px);
	/* display: inline; */
	/* margin-left: 350px; */
	width: calc(100% - 300px);
	/* overflow-y: auto; */
	margin: 0 auto;
	/* margin-top: 61px; */
}

.wjTypeChild {
	width: 80px;
	background-color: #fff;
	padding-top: 15px;
	padding-bottom: 30px;
	float: left;
	display: inline;
}
.display_inline {
	display: inline;
	float: left;
	height: 68px;
	line-height: 68px;
}
.wjTypeChildQuestion {
	margin-left: 2px;
	width: 278px;
	background-color: #fff;
	padding-top: 15px;
	padding-bottom: 30px;
	float: left;
	display: inline;
	overflow-y: auto;
}
.tk_item {
	width: 260px;
	height: 69px;
	margin: 0px auto;
	border-bottom: 1px #d5d5d6 solid;
}

.center {
	text-align: center;
}

.qtypeTitle {
	padding-left: 15px;
	height: 40px;
	line-height: 40px;
	font-weight: bold;
	font-size: 16px;
}

.qtypeItem {
	text-align: center;
	display: inline;
	float: left;
	width: 80px;
	height: 80px;
	border: 1px solid #eaeaea;
}
.dt-title {
	text-align: center;
	margin-top: 20px;
	font-size: 16px;
}
.tx_box {
	width: 100%;
	min-height: 300px;
	margin-top: 30px;
	padding-bottom: 20px;
	background: #fff;
	box-shadow: 1px 3px 17px -5px #aeaeae;
}
.tj_box li {
	flex: 1;
	height: 100%;
	border-right: 1px solid #ccc;
}
.tj_box li p {
	font-size: 16px;
	color: #333;
	margin-bottom: 20px;
}
.tj_box li span {
	font-size: 20px;
	color: red;
}
.tj_box li:last-child {
	border-right: 0;
}
.tj_box {
	width: 100%;
	height: 80px;
	background: #fff;
	box-shadow: 1px 3px 17px -5px #aeaeae;
	margin-top: 30px;
	padding: 20px 0;
}
.title_tj {
	font-size: 18px;
}
.time {
	font-size: 14px;
	color: #666;
}
.display_inline {
	display: inline;
	float: left;
}
.el-header,
.el-footer {
	color: #333;
	text-align: center;
	line-height: 60px;
	padding: 0px;
}
div_aside {
	width: 100%;
	height: 100%;
}
.el-aside {
	max-width: 300px;
	height: 100%;
	text-align: center;
	line-height: 200px;
	color: #333;
	background-color: rgb(12, 146, 255);
	display: inline;
	position: fixed;
	top: 0px;
	right: 16px;
}
.el-main {
	display: inline;
	height: calc(100vh - 60px);
	background-color: #f3f5f6;
}
body > .el-container {
	margin-bottom: 40px;
}
.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
	line-height: 260px;
}
.el-container:nth-child(7) .el-aside {
	line-height: 320px;
}
.el-collapse-item__header {
	padding-left: 6px !important;
	font-weight: 800 !important;
}
.askitem {
	width: 32%;
	height: 80px;
	margin: 1px;
	cursor: pointer;
}
.type-item-icon {
	height: 50px;
	line-height: 86px;
	text-align: center;
}
.type-item-title {
	height: 30px;
	line-height: 30px;
	text-align: center;
	font-size: 8px;
}
.item_container {
	margin-top: 8px;
	background-color: #fff;
	margin-left: 0px !important;
	margin-right: 0px !important;
	padding-top: 6px;
	padding-bottom: 6px;
}
.item_container_hover {
	border: 2px #409eff solid;
	border-radius: 3px;
}
.el-input__inner {
	border-radius: 0;
	padding-left: 5px;
	padding-right: 5px;
}
.el-input__inner:hover {
	background-color: #aaa;
}
.operate_td {
	width: 30px;
	height: 30px;
	font-size: 26px;
	background-color: cornflowerblue;
	text-align: center;
	line-height: 30px;
}
.el-tooltip {
	padding-top: 0px !important;
}
.el-menu-item {
	margin-left: 0px !important;
}
.ck-content {
	min-height: 200px;
}
.el-divider--horizontal {
	margin: 0px !important;
}
.operate_item {
	height: 60px;
	line-height: 60px;
	width: 90%;
	margin: 0px auto;
}
</style>

<style>
/*进度条样式*/
/*上一个*/
.stepsbg .is-finish {
	color: #409eff !important;
}
/*当前*/
.stepsbg .is-process {
	color: #409eff !important;
	border-color: #409eff !important;
}
/*内条有问题的横杠*/
.stepsbg .el-step__line {
	border-color: #409eff !important;
}

.el-collapse-item__header {
	margin-left: 10px !important;
	font-weight: bold;
}

.el-collapse-item__header {
	margin-left: 13px;
	font-weight: bold;
}
/* input都加了移入虚线框*/
input:hover {
	/*border: 1px #aaa dashed !important;*/
}

.option_input > input {
	height: 35px !important;
	line-height: 35px !important;
	border: 1px #aaa solid !important;
}

.option_input > input:hover {
	height: 35px !important;
	line-height: 35px !important;
	border: 1px #aaa solid !important;
}

.left {
	float: left;
	margin-left: 6px;
}



.el-dialog__body {
	/* padding: 0px 7px !important; */
	color: #606266 !important;
	font-size: 14px !important;
	word-break: break-all !important;
}

.el-submenu__title {
	text-align: left !important;
}
</style>
